import React from "react";
import {twMerge} from "tailwind-merge";
import {LoadingBar} from "@components/elements/LoadingBar";

export function Loading(props: { className?: string }) {
    return (
        <div className={twMerge("sticky top-0 z-30", props.className)}>
            <LoadingBar/>
        </div>
    );
}
